<template>
  <headers />
  <div class="el-div1">
    <h3 v-text="info.dataread.title" style="text-align: center"></h3>
    <p v-html="info.dataread.description"></p>
  </div>

  <div id="app">
    <div id="countdown">
      <button
        class="el-button-cuc"
        :class="{ disabled: !info.canClick }"
        @click="countDown"
      >
        {{ info.content }}
      </button>
    </div>
  </div>
</template>
 
 <script>
import { reactive } from "vue";
import { getInfoBaseByType } from "../http/api.ts";
import { GetWebSiteSet } from "../http/api.ts";
import { getTime } from "../http/api.ts";
import { ElMessage } from "element-plus";
import Route from "../router/index";
import headers from "../views/Home.vue";
export default {
  components: { headers },
  setup() {
    let info = reactive({
      dataread: "",
      datasetnumber: 0,
      content: "倒计时开始...",
      totalTime: 10,
      canClick: false,
    });
    let dataFun = async () => {
      await getInfoBaseByType("10").then((res) => {
        info.dataread = res.datas;
      });
    };
    let dataSet = async () => {
      await GetWebSiteSet().then((res) => {
        info.datasetnumber = res.datas.number + 1;
      });
    };
    let settime = () => {
      info.canClick = false;
      //info.content = "请仔细阅读选床须知（" + info.datasetnumber + "s）";
      let clock = setInterval(() => {
        info.datasetnumber--;
        info.content = "请仔细阅读选床须知（" + info.datasetnumber + "s）";
        if (info.datasetnumber < 0) {
          window.clearInterval(clock);
          info.content = "已阅读，开始选床位";
          info.canClick = true;
        }
      }, 1000);
    };
    dataSet();
    dataFun().then(() => {
      settime();
    });
    return { info };
  },
  methods: {
    countDown() {
      if (this.info.canClick) {
        getTime().then((res) => {
          if (res.datas) {
            Route.push("/studentinfo?tmsite="+Math.random());
          } else {
            ElMessage.error({message:res.msg,offset: 300});
          }
        });
      }
    },
  },
};
</script>
 <style>
.el-div1 {
  text-align: left;
  width: 55%;
  margin: 0 auto;
}
.el-button-cuc,
.el-button-cuc:hover,
.el-button-cuc:focus {
  background-image: none;
  background-color: #059490;
  width: calc(30% - 40px);
  line-height: 1;
  padding: 10px 0;
  cursor: pointer;
  border: 1px solid #04726f;
  font-family: "Microsoft YaHei";
  font-size: 16px;
  height: 50px;
  line-height: 25px;
  border-radius: 6px;
  margin: 8px 0 0 21px;
  color: #fff;
  text-align: center;
  position: relative;
  box-sizing: border-box;
}
.disabled {
  background-color: #ddd;
  border-color: #ddd;
  color: #000;
  cursor: not-allowed;
}
</style>